export const RESULT_TYPE = {
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
};
